export default __webpack_public_path__ + "locales/sl/Files.json?hash=fa5dd1a82c9956cb0b7361dbcae2738a";